import {
  Recycle,
  Phone,
} from "lucide-react";
import { COMPANY } from "../lib/company";

const CERTIFICATIONS = [
  {
    icon: Recycle,
    title: "Transporttillstånd",
    sub: "Avfall & Restprodukter",
    desc: "Tillstånd från Länsstyrelsen för transport av farligt och icke-farligt avfall.",
  },
];

export default function Tillstand() {
  return (
    <div data-testid="page-tillstand">
      {/* Page Header */}
      <section
        className="bg-black text-white py-20 lg:py-28 relative overflow-hidden"
        data-testid="tillstand-header"
      >
        <div className="hero-grain" />
        <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
          <p className="overline text-[#FFD700] mb-5">Säkerhet & Kvalitet</p>
          <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Tillstånd
            <br />
            &amp; <span className="text-[#FFD700]">Certifikat.</span>
          </h1>
          <p className="mt-6 text-lg text-gray-300 max-w-2xl leading-relaxed">
            Vi arbetar enligt branschens högsta krav på säkerhet, miljö och
            kompetens. Här är våra viktigaste behörigheter.
          </p>
        </div>
      </section>

      {/* Cert Grid */}
      <section
        className="bg-white py-20 lg:py-28"
        data-testid="cert-grid-section"
      >
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {CERTIFICATIONS.map((c, i) => {
              const Icon = c.icon;
              return (
                <div
                  key={i}
                  className="bg-white border-2 border-black p-8 flex flex-col"
                  data-testid={`cert-${i}`}
                >
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-14 h-14 bg-[#FFD700] border-2 border-black flex items-center justify-center">
                      <Icon size={26} strokeWidth={2.5} />
                    </div>
                    <span className="font-display font-black text-gray-200 text-5xl leading-none">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-display font-black text-2xl text-black mb-1 uppercase tracking-tight">
                    {c.title}
                  </h3>
                  <p className="overline text-[#166534] mb-4">{c.sub}</p>
                  <p className="text-gray-700 leading-relaxed">{c.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Safety Commitment */}
      <section
        className="bg-[#111827] text-white py-20 lg:py-28"
        data-testid="safety-section"
      >
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
            <div className="lg:col-span-5">
              <p className="overline text-[#FFD700] mb-5">Vårt åtagande</p>
              <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight">
                Säkerhet före allt annat.
              </h2>
              <p className="mt-6 text-gray-300 text-lg leading-relaxed">
                Tunga maskiner och stora fordon kräver tunga rutiner. Vi
                investerar löpande i utbildning, underhåll och utrustning för
                att hålla våra medarbetare, kunder och allmänheten trygga.
              </p>
            </div>
            <div className="lg:col-span-7 space-y-4">
              {[
                {
                  t: "Daglig fordonskontroll",
                  d: "Varje fordon och maskin kontrolleras före varje arbetspass enligt vår underhållsplan.",
                },
                {
                  t: "Miljöansvarig hantering",
                  d: "Vi sorterar, återvinner och dokumenterar avfall enligt gällande miljöregler.",
                },
                {
                  t: "Försäkrade uppdrag",
                  d: "Företaget är fullt försäkrat med ansvars- och entreprenadförsäkringar.",
                },
                {
                  t: "F-skattsedel",
                  d: "Båda bolagen har F-skattsedel och är registrerade för moms och arbetsgivaravgifter.",
                },
              ].map((s, i) => (
                <div
                  key={i}
                  className="border-l-4 border-[#FFD700] bg-black/40 p-6"
                  data-testid={`safety-item-${i}`}
                >
                  <h3 className="font-display font-bold text-xl mb-1">
                    {s.t}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">{s.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="bg-white py-16 lg:py-24 border-t-2 border-black"
        data-testid="tillstand-cta"
      >
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-2xl text-black">
            Frågor om ett specifikt tillstånd?
          </h2>
          <a
            href={COMPANY.phoneHref}
            className="inline-flex items-center gap-3 bg-[#FFD700] text-black font-bold px-8 py-5 border-2 border-black hover:bg-yellow-400 transition-colors"
            data-testid="tillstand-cta-phone"
          >
            <Phone size={22} strokeWidth={2.5} />
            <span className="font-display font-black text-xl lg:text-2xl">
              {COMPANY.phone}
            </span>
          </a>
        </div>
      </section>
    </div>
  );
}
